/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextArticleTIcon24Regular = forwardRef('TextArticleTIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M2 3a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-2.5v5.5a.75.75 0 0 1-1.5 0v-5.5h-2.5A.75.75 0 0 1 2 3Z" }),
        React.createElement("path", { d: "M12.75 3.25a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5Z" }),
        React.createElement("path", { d: "M12.75 8.25a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5Z" }),
        React.createElement("path", { d: "M3.75 18.25a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5H3.75Z" }),
        React.createElement("path", { d: "M3 14a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 14Z" })));
});
